export enum ErrorCodes {
  NON_ORDERABLE_ORDER = 30004,
  CSRF_CODE = 54009,
  ANSWERED_SURVEY_CODE = 40003,
}
